
const rootState = {
  controllers: {},  
};
const getterObject = {};
const actionObject = {};

let klasses = [
  { name: "RoutesController", path: '/routes',  object_name: 'route', collection_name: 'routes', label: 'ruter' },
  { name: "PeopleController", path: '/people',  object_name: 'person', collection_name: 'people', label: 'Personer' },
  { name: "OwnershipsController", path: '/ownerships',  object_name: 'ownership', collection_name: 'ownerships', label: 'Ejerskaber' },
  { name: "EntitiesController", path: '/entities',  object_name: 'entity', collection_name: 'entities', label: 'Entiteter' },
  { name: "EntityRelationsController", path: '/entity_relations',  object_name: 'entity_relation', collection_name: 'entity_relations', label: 'Entitetsrelationer' },
  { name: "PersonConsultantsController", path: '/person_consultants',  object_name: 'person_consultant', collection_name: 'person_consultants', label: 'Personkonsulenter' },
  { name: "IssuesController", path: '/issues',  object_name: 'issue', collection_name: 'issues', label: 'Værdipapirer' },
  { name: "CurrenciesController", path: '/currencies',  object_name: 'currency', collection_name: 'currencies', label: 'Valutaer' },
  { name: "CurrencyRatesController", path: '/currency_rates',  object_name: 'currency_rate', collection_name: 'currency_rates', label: 'Valutakurser' },
  { name: "CoractsController", path: '/coracts',  object_name: 'coract', collection_name: 'coracts', label: 'Coracts' },
  { name: "CovariancesController", path: '/covariances',  object_name: 'covariance', collection_name: 'covariances', label: 'Kovarianser' },
  { name: "DocumentsController", path: '/documents',  object_name: 'document', collection_name: 'documents', label: 'Dokumenter' },
  { name: "DocumentNotesController", path: '/document_notes',  object_name: 'document_note', collection_name: 'document_notes', label: 'Dokumentnoter' },
  { name: "DocumentRelationsController", path: '/document_relations',  object_name: 'document_relation', collection_name: 'document_relations', label: 'Dokumentrelationer' },
  { name: "DocumentGroupsController", path: '/document_groups',  object_name: 'document_group', collection_name: 'document_groups', label: 'Dokumentgrupper' },
  { name: "InvestmentReportsController", path: '/investment_reports',  object_name: 'investment_report', collection_name: 'investment_reports', label: 'Investeringsrapporter' },
  { name: "InvestmentCostReportsController", path: '/investment_cost_reports',  object_name: 'investment_cost_report', collection_name: 'investment_cost_reports', label: 'Investeringsomkostningsrapporter' },
  { name: "DocumentPrivilegesController", path: '/document_privileges',  object_name: 'document_privilege', collection_name: 'document_privileges', label: 'Dokumentrettigheder' },
  { name: "VehicleCostEstimatesController", path: '/vehicle_cost_estimates',  object_name: 'vehicle_cost_estimate', collection_name: 'vehicle_cost_estimates', label: 'Køretøjsomkostningsestimater' },
  { name: "PricesController", path: '/prices',  object_name: 'price', collection_name: 'prices', label: 'Priser' },
  { name: "AccountsController", path: '/accounts',  object_name: 'account', collection_name: 'accounts', label: 'Konti' },
  { name: "AccountRatesController", path: '/account_rates',  object_name: 'account_rate', collection_name: 'account_rates', label: 'Kontokurser' },
  { name: "FeeRatesController", path: '/fee_rates',  object_name: 'fee_rate', collection_name: 'fee_rates', label: 'Gebyrkurser' },
  { name: "FeesController", path: '/fees',  object_name: 'fee', collection_name: 'fees', label: 'Gebyrer' },
  { name: "ContactInformationsController", path: '/contact_informations',  object_name: 'contact_information', collection_name: 'contact_informations', label: 'Kontaktinformationer' },
  { name: "DepositsController", path: '/deposits',  object_name: 'deposit', collection_name: 'deposits', label: 'Indbetalinger' },
  { name: "InvestmentCostsController", path: '/investment_costs',  object_name: 'investment_cost', collection_name: 'investment_costs', label: 'Investeringsomkostninger' },
  { name: "InvestmentReturnsController", path: '/investment_returns',  object_name: 'investment_return', collection_name: 'investment_returns', label: 'Investeringsafkast' },
  { name: "LaunderingEventsController", path: '/laundering_events',  object_name: 'laundering_event', collection_name: 'laundering_events', label: 'Hvidvaskhændelser' },
  { name: "EventsController", path: '/events',  object_name: 'event', collection_name: 'events', label: 'Hændelser' },
  { name: "InvestmentsController", path: '/investments',  object_name: 'investment', collection_name: 'investments', label: 'Investeringer' },
  { name: "LossWarningsController", path: '/loss_warnings',  object_name: 'loss_warning', collection_name: 'loss_warnings', label: 'Tabadvarsler' },
  { name: "MeetingSummariesController", path: '/meeting_summaries',  object_name: 'meeting_summary', collection_name: 'meeting_summaries', label: 'Mødereferater' },
  { name: "UsersController", path: '/users',  object_name: 'user', collection_name: 'users', label: 'Brugere' },
  { name: "HealthChecksController", path: '/health_checks',  object_name: 'health_check', collection_name: 'health_checks', label: 'Sundhedstjek' },
  { name: "TagsController", path: '/tags',  object_name: 'tag', collection_name: 'tags', label: 'Tags' },
  { name: "EventRelationsController", path: '/event_relations',  object_name: 'event_relation', collection_name: 'event_relations', label: 'Hændelsesrelationer' },
  { name: "ApplicationRecordLogsController", path: '/application_record_logs',  object_name: 'application_record_log', collection_name: 'application_record_logs', label: 'Applikationslog' },
  { name: "OnboardingsController", path: '/onboardings',  object_name: 'onboarding', collection_name: 'onboardings', label: 'Onboarding' },
  { name: "OnboardingStepsController", path: '/onboarding_steps',  object_name: 'onboarding_step', collection_name: 'onboarding_steps', label: 'Onboarding trin' },
  { name: "OnboardingStepDataController", path: '/onboarding_step_data',  object_name: 'onboarding_step_datum', collection_name: 'onboarding_step_data', label: 'Onboarding trin data' },
  { name: "AllocationLimitsController", path: '/allocation_limits',  object_name: 'allocation_limit', collection_name: 'allocation_limits', label: 'Tildelingsgrænser' },
  { name: "RiskAssessmentsController", path: '/risk_assessments',  object_name: 'risk_assessment', collection_name: 'risk_assessments', label: 'Risikovurderinger' },
  { name: "TradeSuggestionsController", path: '/trade_suggestions',  object_name: 'trade_suggestion', collection_name: 'trade_suggestions', label: 'Handelsforslag' },
  { name: "EventLoadsController", path: '/event_loads',  object_name: 'event_load', collection_name: 'event_loads', label: 'Hændelsesindlæsninger' },
  { name: "EventLoadLogsController", path: '/event_load_logs',  object_name: 'event_load_log', collection_name: 'event_load_logs', label: 'Hændelsesindlæsningslog' },
  { name: "LossWarningLossesController", path: '/loss_warning_losses',  object_name: 'loss_warning_loss', collection_name: 'loss_warning_losses', label: 'Tabadvarseltab' },
  { name: "AssetClassGroupsController", path: '/asset_class_groups',  object_name: 'asset_class_group', collection_name: 'asset_class_groups', label: 'Aktivklassegrupper' },
  { name: "EntityReportingGroupsController", path: '/entity_reporting_groups',  object_name: 'entity_reporting_group', collection_name: 'entity_reporting_groups', label: 'Entitetsrapporteringsgrupper' },
  { name: "BenchmarkSetupsController", path: '/benchmark_setups',  object_name: 'benchmark_setup', collection_name: 'benchmark_setups', label: 'Benchmarkopsætninger' },
  { name: "BenchmarkWeightsController", path: '/benchmark_weights',  object_name: 'benchmark_weight', collection_name: 'benchmark_weights', label: 'Benchmarkvægte' },
  { name: "InvoiceTypesController", path: '/invoice_types',  object_name: 'invoice_type', collection_name: 'invoice_types', label: 'Fakturatyper' },
  { name: "InvoiceTypeIntervalsController", path: '/invoice_type_intervals',  object_name: 'invoice_type_interval', collection_name: 'invoice_type_intervals', label: 'Fakturatypeintervaller' },
  { name: "InvoiceTypeIntervalLinesController", path: '/invoice_type_interval_lines',  object_name: 'invoice_type_interval_line', collection_name: 'invoice_type_interval_lines', label: 'Fakturatypeinterval linjer' },
  { name: "PersonFamiliesController", path: '/person_families',  object_name: 'person_family', collection_name: 'person_families', label: 'Personfamilier' },
  { name: "IssueTaxStructuresController", path: '/issue_tax_structures',  object_name: 'issue_tax_structure', collection_name: 'issue_tax_structures', label: 'Værdipapirskattestrukturer' },
  { name: "EntityInvoiceTypesController", path: '/entity_invoice_types',  object_name: 'entity_invoice_type', collection_name: 'entity_invoice_types', label: 'Entitetsfakturatyper' },
  { name: "ManualFeesController", path: '/manual_fees',  object_name: 'manual_fee', collection_name: 'manual_fees', label: 'Manuelle gebyrer' },
  { name: "EntityCommitmentsController", path: '/entity_commitments',  object_name: 'entity_commitment', collection_name: 'entity_commitments', label: 'Entitetsforpligtelser' },
  { name: "DataSelectorsController", path: '/data_selectors',  object_name: 'data_selector', collection_name: 'data_selectors', label: 'Datavælgere' },
  { name: "SailsLogsController", path: '/sails_logs',  object_name: 'sails_log', collection_name: 'sails_logs', label: 'Sails logs' },
  { name: "SailsLogChecksController", path: '/sails_log_checks',  object_name: 'sails_log_check', collection_name: 'sails_log_checks', label: 'Sails log checks' },
  { name: "MailGroupsController", path: '/mail_groups',  object_name: 'mail_group', collection_name: 'mail_groups', label: 'Mailgrupper' },
  { name: "MailGroupUsersController", path: '/mail_group_users',  object_name: 'mail_group_user', collection_name: 'mail_group_users', label: 'Mailgruppebrugere' },
  { name: "MailGroupActionsController", path: '/mail_group_actions',  object_name: 'mail_group_action', collection_name: 'mail_group_actions', label: 'Mailgruppehandlinger' },
  { name: "SailsLogSubscriptionsController", path: '/sails_log_subscriptions',  object_name: 'sails_log_subscription', collection_name: 'sails_log_subscriptions', label: 'Sails log abonnementer' },
  { name: "EntityInvoiceFeesController", path: '/entity_invoice_fees',  object_name: 'entity_invoice_fee', collection_name: 'entity_invoice_fees', label: 'Entitetsfakturagebyrer' },
  { name: "ReportingsController", path: '/reportings',  object_name: 'reporting', collection_name: 'reportings', label: 'Rapporteringer' },
  { name: "ReportingTypesController", path: '/reporting_types',  object_name: 'reporting_type', collection_name: 'reporting_types', label: 'Rapporteringstyper' },
  { name: "EntityAllocationsController", path: '/entity_allocations',  object_name: 'entity_allocation', collection_name: 'entity_allocations', label: 'Entitetsallokeringer' },
  { name: "EntityVehicleCostEstimatesController", path: '/entity_vehicle_cost_estimates',  object_name: 'entity_vehicle_cost_estimate', collection_name: 'entity_vehicle_cost_estimates', label: 'Entitetskøretøjsomkostningsestimater' },
  { name: "EventRefundSplitsController", path: '/event_refund_splits',  object_name: 'event_refund_split', collection_name: 'event_refund_splits', label: 'Hændelsesrefusionssplit' },
  { name: "IssueFundGroupsController", path: '/issue_fund_groups',  object_name: 'issue_fund_group', collection_name: 'issue_fund_groups', label: 'Værdipapirfondgrupper' },
  { name: "BanksController", path: '/banks',  object_name: 'bank', collection_name: 'banks', label: 'Banker' },
  { name: "EntityBenchmarksController", path: '/entity_benchmarks',  object_name: 'entity_benchmark', collection_name: 'entity_benchmarks', label: 'Entitetsbenchmark' },
  { name: "SailsHelpTextsController", path: '/sails_help_texts',  object_name: 'sails_help_text', collection_name: 'sails_help_texts', label: 'Sails hjælpetekster' },
  { name: "TransactionRulesController", path: '/transaction_rules',  object_name: 'transaction_rule', collection_name: 'transaction_rules', label: 'Transaktionsregler' },
  { name: "AccountBalancesController", path: '/account_balances',  object_name: 'account_balance', collection_name: 'account_balances', label: 'Kontosaldi' },
  { name: "DepositBalancesController", pat1h: '/deposit_balances',  object_name: 'deposit_balance', collection_name: 'deposit_balances', label: 'Depotsaldi' },
  { name: "IsinMappingsController", path: '/isin_mappings',  object_name: 'isin_mapping', collection_name: 'isin_mappings', label: 'IsinMapping' },
  { name: "BankImportRulesController", path: '/bank_import_rules',  object_name: 'bank_import_rule', collection_name: 'bank_import_rules', label: 'Regler for bankimport' },
  { name: "DepositReconciliationHistoriesController", path: '/deposit_reconciliation_histories',  object_name: 'deposit_reconciliation_history', collection_name: 'deposit_reconciliation_histories', label: 'Deposit Reconciliation History' },
  { name: "EntityCostsController", path: '/entity_costs',  object_name: 'entity_cost', collection_name: 'entity_costs', label: 'Entity Costs' },
  { name: "EntityCostTypesController", path: '/entity_cost_types',  object_name: 'entity_cost_type', collection_name: 'entity_cost_types', label: 'Entity Cost Types' },
  { name: "EntityCostNamesController", path: '/entity_cost_names',  object_name: 'entity_cost_name', collection_name: 'entity_cost_names', label: 'Entity Cost Names' },
  { name: "UpdateMessagePoliciesController", path: '/update_message_policies',  object_name: 'update_message_policy', collection_name: 'update_message_policies', label: 'Politikker for opdateringer'},
  { name: "DataStagingsController", path: '/data_stagings',  object_name: 'data_staging', collection_name: 'data_stagings', label: 'Datasamling' },
  { name: "DataStagingLogsController", path: '/data_staging_logs',  object_name: 'data_staging_log', collection_name: 'data_staging_logs', label: 'Datasamling Log' },
  { name: "AifsController", path: '/aifs',  object_name: 'aif', collection_name: 'aifs', label: 'Alternative investeringsfonde' },
  { name: "AifCommitmentsController", path: '/aif_commitments',  object_name: 'aif_commitment', collection_name: 'aif_commitments', label: 'AIF tilsagn' },
  { name: "AifTransactionsController", path: '/aif_transactions',  object_name: 'aif_transaction', collection_name: 'aif_transactions', label: 'AIF transaktioner' },
  { name: "AifCommitmentTransactionsController", path: '/aif_commitment_transactions',  object_name: 'aif_commitment_transaction', collection_name: 'aif_commitment_transactions', label: 'AIF tilsagnstransaktioner' },
  { name: "EntityPricesController", path: '/entity_prices',  object_name: 'entity_price', collection_name: 'entity_prices', label: 'Mandatkurser' },
];

function klassName(name){
  if (name === null || name === undefined || name === '') {
    return {};
  }

  if (typeof name === 'object') {
    return name;
  }

  const instance = klasses.find((c) => {
    return c.collection_name.toLowerCase() === name.toLowerCase() || c.object_name.toLowerCase() === name.toLowerCase() || c.name.toLowerCase() === name.toLowerCase()
    || c.name.toLowerCase().replace('controller', '') === name.toLowerCase() 
  })

  return instance
}
// Sync function for getting controller
function getController(name){
  const controllerName = klassName(name);
  if (controllerName === null || controllerName === undefined) {
    window.console.log(`Controller ${name} not found`);
    return null;
  }
  return rootState.controllers[controllerName.name];
}

import { reactive } from 'vue';
async function instance(name) {
  const controllerName = klassName(name);

  if (rootState.controllers[controllerName.name]) {
    return rootState.controllers[controllerName.name];
  }

  const controllerModule = await import(`stores/controllers/controllerFiles/${controllerName.name}.js`);
  const controller_class = controllerModule.default;
  const instance = new controller_class();

  // If instance is null give an error
  if (!instance) {
    window.console.log(`Controller ${controllerName.name} not found`);
  }
  const reactiveInst = reactive(instance);

  rootState.controllers[controllerName.name] = reactiveInst;

  return instance;
}

klasses.forEach((klass) => {
  let object_name = ''
  let collection_name = ''
  
  object_name = klass['object_name']
  collection_name = klass['collection_name']
  rootState[collection_name] = [];

  instance(collection_name);
  
  // GET_CLIENTS
  actionObject["GET_" + collection_name.toUpperCase()] = (payload) => {
    const c = getController(object_name);
    return c.requestData(payload);
  };
  // GET_CLIENT
  actionObject["GET_" + object_name.toUpperCase()] = ({ id, query }) => {
    const c = getController(object_name);
    return c.requestDatum(id, query || {});
  };
  // NEW_CLIENT
  getterObject["NEW_" + object_name.toUpperCase()] = () => (obj) => {
    const c = getController(object_name);
    return c.setNewDatum(obj);
  };
  // FIND_CLIENT
  getterObject["FIND_" + object_name.toUpperCase() + "_AT"] = (state) => (id) => {
    const c = getController(object_name);
    return c.findDatumAt(id);
  };
  // UPDATE_CLIENT
  actionObject["UPDATE_" + object_name.toUpperCase()] = (payload) => {
    const c = getController(object_name);
    return c.updateDatum(payload);
  };
  // CREATE_CLIENT
  actionObject["CREATE_" + object_name.toUpperCase()] = (payload) => {
    const c = getController(object_name);
    return c.createDatum(payload);
  };
  // DELETE_CLIENT
  actionObject["DELETE_" + object_name.toUpperCase()] = (payload) => {
    const c = getController(object_name);
    return c.destroyDatum(payload);
  };
  // SPREADSHEET
  actionObject["SPREADSHEET_" + object_name.toUpperCase()] =  (payload) => {
    const c = getController(object_name);
    return c.toSpreadSheet(payload);
  };
  // CLIENTS_COLLECTED - i.e. has GET_CLIENTS been called
  getterObject[collection_name.toUpperCase() + "_COLLECTED"] =  (payload) => {
    const c = getController(object_name);
    return c.collected;
  };
});

// GET_CONTROLLER_INSTANCE
getterObject["GET_CONTROLLER_INSTANCE"] = (state) => (name) => {
  return getController(name);
};

// CUSTOM ACTIONS
actionObject["CHECK_EVENTS"] = (payload) => {
  const c = getController('event');
  return c.checkEvents(payload.id, payload.check);
};
actionObject["SET_EVENT_BALANCES"] = () => {
  const c = getController('event');
  return c.setBalances();
};
actionObject["FIND_INVESTMENT"] = (payload) => {
  const c = getController('investment');
  return c.findInvestment(payload);
};
actionObject["GET_COVMAT"] = ({ rootState }, ids) => {
  const c = getController('covmat');
  return c.getCovmat(ids);
};
actionObject["LINK_EVENT"] = (payload) => {
  const c = getController('event');
  return c.linkCandidate(payload);
};
actionObject["GET_PERIODIC_FEES"] = (payload) => {
  const c = getController('fees');
  return c.getPeriodicFees(payload);
};

export const state = rootState;
export const getters = getterObject;
export const actions = actionObject;
